import React from 'react';
import { Card } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import CardItem from '@/components/cards/CardItem';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import { formatDate } from '@/utils/dateHelper';
import { validationStatusIconProps } from '../helper';
import DataManagementDictionaryToolsMenu from './DataManagementDictionaryToolsMenu';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import ReportsEvents from '../../reports/hooks/events';

const DataManagementDictionaryCardItem = ({
  category,
  code,
  dictionaryCode,
  upward,
}) => {
  const intl = useIntl();
  const {
    allowConversion,
    dataTableExists,
    dictionaryName,
    disableConvert,
    disableValidate,
    isLoading,
    lastValidationDate,
    rowCount,
    valid,
  } = Selectors.useDataManagementDictionaryItem(category, code, dictionaryCode);
  const showStatus = Events.useShowValidateDictionaryDataStatus(category, { code });
  const showReports = ReportsEvents.useShowDictionaryReports(category, { code: dictionaryCode });
  const validate = Events.useValidateDictionaryData(category, { code });
  const convert = Events.useConvertDictionaryData(category, { code });

  return (
    <CardItem className="aridhia-data-management-dictionary-item">
      <NameDescriptionCard
        entity="dictionary"
        href={disableValidate ? undefined : '#'}
        icon={validationStatusIconProps(valid).name}
        iconColour={isLoading ? undefined : validationStatusIconProps(valid).colour}
        iconMessage={intl.formatMessage({ id: validationStatusIconProps(valid).message })}
        name={dictionaryName}
        loading={isLoading}
        meta={
          lastValidationDate
            ? intl.formatMessage({
              id: 'dataset.data.validation.date',
            }, { date: formatDate(lastValidationDate) })
            : undefined
        }
        onClick={disableValidate ? undefined : () => showStatus(category, code, dictionaryCode, dictionaryName, true)}
        title={intl.formatMessage({ id: validationStatusIconProps(valid).message })}
      >
        <div className="float-r">
          <DataManagementDictionaryToolsMenu
            allowConversion={allowConversion}
            category={category}
            code={code}
            convert={convert}
            dictionaryCode={dictionaryCode}
            dictionaryName={dictionaryName}
            disableConvert={disableConvert || isLoading}
            disableValidate={disableValidate || isLoading}
            listItem
            showReports={showReports}
            upward={upward}
            validate={validate}
          />
        </div>
      </NameDescriptionCard>
      <Card.Content extra>
        {dataTableExists && (<FormattedMessage id="dataset.data.table.exists.yes.text" values={{ rowCount }} />)}
        {!dataTableExists && (<FormattedMessage id="dataset.data.table.exists.no.text" />)}
      </Card.Content>
    </CardItem>
  );
};

export default DataManagementDictionaryCardItem;
